// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuid } from 'uuid'
import VisitRemarksCardItem from '../../../../../components/VisitRemarksCardItem/VisitRemarksCardItem'
import { getAuthorName } from '../../../../../utils/common'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitRemarksContent = ({ remarks = [], userTimeZone, userTimeZoneAbbr, isFormOpened }) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const sortedRemarks = remarks.remarksList?.sort((a, b) => new Date(b.DateTime) - new Date(a.DateTime))

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return sortedRemarks?.map((remark) => {
    const key = uuid()

    return (
      <VisitRemarksCardItem
        key={key}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        isEditAllowed={remark?.IsEditAllowed}
        isEdited={remark?.IsEdited}
        isFormOpened={isFormOpened}
        dateTime={remark?.DateTime}
        message={remark?.Message}
        author={getAuthorName(remark?.Author, false)}
        role={remark?.Author?.UserType}
        remarkId={remark?.RemarkId}
        index={key}
        userTimeZone={userTimeZone}
        userTimeZoneAbbr={userTimeZoneAbbr}
      />
    )
  })
}
